import { isNil } from 'lodash';
import { FC } from 'react';
import Toast from 'components/Toast';
import classlist from 'utils/classlist';
import copyMe from 'utils/copyMe';
import './style.scss';

interface ItemProps {
    label?: React.ReactNode;
    value?: string | number;
    meta?: string;
    isShowbg?: boolean; // 是否展示背景色
    required?: boolean; // 是否必填
}

const Item: FC<ItemProps> = ({ label, value, meta, isShowbg, required }) => {
    const handleCopy = () => {
        Toast.show(copyMe(`${value || ''}`) ? __('复制成功！') : __('复制失败，请手动复制'));
    };

    if (isNil(value) && !meta) {
        return null;
    }

    return (
        <div className="bank-info-items">
            {!isNil(value) && (
                <div className="item-container" onClick={handleCopy}>
                    <div className="collection-item-left">
                        {label && <p className="list-items-title">{label}</p>}
                        {required && <span className="required">{__('(Required)')}</span>}
                        <div className="list-value">
                            <p
                                className={classlist('list-items-mess', {
                                    'tip-bg': isShowbg
                                })}>
                                {value}
                            </p>
                            <div className={'prompt-text'}>{__('复制')}</div>
                        </div>
                    </div>
                </div>
            )}
            {meta && <div className="swift-prompt">{meta}</div>}
        </div>
    );
};

export default Item;
